import "./TextRenderAnimationComponent.scss";
import { motion } from "framer-motion";
import { cn } from "@/utils/clsx";
import {ReactNode, useEffect, useRef, useState} from "react";

interface TextRenderAnimationComponentProps {
    words: string;
    className?: string;
    filter?: boolean;
    duration?: number;
    delay?: number;
    children?: ReactNode;          // Content to show after animation
}

const TextRenderAnimationComponent = ({
                                          words,
                                          className,
                                          filter = true,
                                          duration = 0.5,
                                          delay = 0,
                                          children
                                      }: TextRenderAnimationComponentProps) => {
    const [done, setDone] = useState(false);
    const wordsArray = words.split("");
    const afterAnimationRef = useRef<HTMLDivElement>(null);

    const letterVariants = {
        hidden: { opacity: 0, y: 10, filter: filter ? "blur(3px)" : "none" },
        visible: (custom: number) => ({
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            transition: {
                duration,
                delay: delay + custom * 0.007,
            },
        }),
    };

    useEffect(() => {
        if (done && afterAnimationRef.current) {
            afterAnimationRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [done]);

    return (
        <div className={cn("text-animation-container", className)}>
            <motion.div
                initial="hidden"
                animate="visible"
                className="word-container"
                onAnimationComplete={() => setDone(true)}
            >
                {wordsArray.map((letter, idx) => (
                    <motion.span
                        key={`${letter}-${idx}`}
                        custom={idx}
                        variants={letterVariants}
                        className="letter"
                    >
                        {letter}
                    </motion.span>
                )) as ReactNode}
            </motion.div>
            {done && <div ref={afterAnimationRef} className="after-animation-content">{children}</div>}
        </div>
    );
};

export default TextRenderAnimationComponent;
